import { Link } from 'react-router-dom';
import { MAIN_SITE_URL } from '@/utils/constants';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold whitespace-nowrap">Sugargoo Spreadsheet</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              Your trusted resource hub for Sugargoo product discovery, shopping guides, and spreadsheet resources. Helping shoppers make smarter decisions.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
              <a href="#categories" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Product Categories</a>
              <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Complete Guide</Link>
              <Link to="/sugargoo-beginner-guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Beginner Guide</Link>
              <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Main Website</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">SEO Resources</h4>
            <div className="flex flex-col gap-2">
              <Link to="/sugargoo-review" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Sugargoo Review</Link>
              <Link to="/sugargoo-shipping-cost" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Shipping Cost Guide</Link>
              <Link to="/sugargoo-coupon" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Coupon Guide</Link>
              <Link to="/sugargoo-warehouse" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Warehouse Guide</Link>
              <Link to="/is-sugargoo-legit" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Is Sugargoo Legit?</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">Popular Guides</h4>
            <div className="flex flex-col gap-2">
              <Link to="/sugargoo-finds" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Best Sugargoo Finds</Link>
              <Link to="/sugargoo-discount-code" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Discount Codes</Link>
              <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Spreadsheet Guide</Link>
              <a href="#categories" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Browse Categories</a>
              <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">Visit Sugargoo Store</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All rights reserved. Independent informational resource.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
            <Link to="/sugargoo-spreadsheet-guide" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Guide</Link>
            <Link to="/sugargoo-review" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Review</Link>
            <a href={MAIN_SITE_URL} target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Main Site</a>
          </div>
        </div>
      </div>
    </footer>
  );
}